import { ColumnLayoutListProps } from '@/components/atomic/templates/navigation/column-layout-list/typings';
import { EditableComponentProps } from '@adobe/aem-react-editable-components';
import { EnvVarsService } from '@multitenancy-spa/env-vars-service/esm/services/env-vars-service';

const config = {
	emptyLabel: 'Column Layout List',
	isEmpty: (props: EditableComponentProps & ColumnLayoutListProps) =>
		!props.columnLayouts?.length,
	resourceType: `${EnvVarsService.getVar('VITE_APP_ID')}/components/columnLayoutList`,
};

export default config;
